import { render, staticRenderFns } from "./sessions-details-list.vue?vue&type=template&id=1f9e8350"
import script from "./sessions-details-list.vue?vue&type=script&lang=js"
export * from "./sessions-details-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports